<div class="kanban-column" [class]="columnColorClass()" data-testid="kanban-column">
  <div class="column-header">
    <div class="header-left">
      <mat-icon>{{ icon }}</mat-icon>
      <span class="column-title">{{ title }}</span>
    </div>
    <span class="ticket-count" [attr.data-testid]="'column-count-' + columnType()"> {{tickets.length }}</span>
  </div>

  <div class="column-content">
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else if (tickets.length === 0) {
      <div class="empty-state">
        <mat-icon>inbox</mat-icon>
        <span>{{ emptyMessage }}</span>
      </div>
    } @else {
      <div class="tickets-list">
        @for (ticket of tickets; track ticket.Id) {
          <app-ticket-card
            [ticket]="ticket"
            [isSelected]="ticket.Id === selectedTicketId"
            [showQuickActions]="columnType() !== 'resolved'"
            (cardClicked)="onTicketClicked($event)"
            (assignToMe)="onAssignToMe($event)">
          </app-ticket-card>
        }
      </div>
    }
  </div>
</div>
